module.exports = __webpack_public_path__ + "src/img/verify-success-logo.2b06a8a1.svg";